
import React, { useState, useEffect } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ActionGrid } from '@/components/actions/ActionGrid';
import { BarometerPopup } from '@/components/actions/BarometerPopup';
import { ICFAnnouncementCard } from '@/components/actions/ICFAnnouncementCard';
import { ExprimeCharteCard } from '@/components/actions/ExprimeCharteCard';
import { useLocation } from 'react-router-dom';

const Actions = () => {
  const [showBarometerPopup, setShowBarometerPopup] = useState(false);
  const location = useLocation();

  // Log when component mounts or updates
  useEffect(() => {
    console.log('[DEBUG Actions] Component mounted/updated', { 
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      from: document.referrer || 'direct navigation',
      hostname: window.location.hostname,
      href: window.location.href
    });
  }, [location]);

  const handleBarometerButtonClick = () => {
    console.log('Barometer button clicked');
    setShowBarometerPopup(true);
  };

  return (
    <div className="min-h-screen bg-[#F7F7F7]">
      <Header />
      <section className="relative pt-24 pb-8 md:pt-28 md:pb-12 overflow-hidden">
        <div className="container max-w-6xl mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-[#00123A] mb-6 animate-fade-in">Nos actualités et actions</h1>
          </div>

          <div className="mb-8">
            <ICFAnnouncementCard />
          </div>

          <div className="mb-8">
            <ExprimeCharteCard />
          </div>

          <ActionGrid 
            onShowBarometerPopup={handleBarometerButtonClick}
          />
        </div>
      </section>

      {/* Popups using Dialog component from shadcn */}
      <BarometerPopup
        isVisible={showBarometerPopup} 
        onClose={() => setShowBarometerPopup(false)} 
      />

      <Footer />
      <Toaster />
    </div>
  );
};

export default Actions;
